import './index.less'
import { useEffect, useState, useMemo } from 'react';
import { Empty } from 'antd';
import PdfViewModal from '@/components/PdfViewModal';
import iconPeixun from '@/assets/images/support/icon-peixun.png';
import iconRenzheng from '@/assets/images/support/icon-renzheng.png';
import iconYouxiu from '@/assets/images/support/icon-youxiu.png';
import iconDownload from '@/assets/images/support/icon-download.png';
import iconView from '@/assets/images/support/icon-view.png';
import { getMyCertificate, getMyCertificatePreview } from '@/api/certificate';

const Certificate = () => {

  const [pdfViewModalData, setPdfViewModalData] = useState<any>(null);
  const [certificateTypeList, setCertificateTypeList] = useState<any[]>([
    {
      name: '全部',
      value: 'all',
      icon: null,
    },
    {
      name: '认证证书',
      value: 'CERTIFICATION',
      icon: iconRenzheng,
    },
    {
      name: '培训证书',
      value: 'TRAINING',
      icon: iconPeixun,
    },
    {
      name: '优秀学员证书',
      value: 'EXCELLENT',
      icon: iconYouxiu,
    }
  ])
  const [certificateList, setCertificateList] = useState<any[]>([]);
  const [certificateType, setCertificateType] = useState('all');
  const certificateListMemo = useMemo(() => {
    return certificateList.filter((item) => certificateType === 'all' || item.certificateType === certificateType);
  }, [certificateList, certificateType]);

  const viewCertificate = (record: any) => {
    getMyCertificatePreview(record.id).then((res: any) => {
      if (res.success) {
        setPdfViewModalData(res.result);
      }
    });
  };

  const downloadCertificate = (record: any) => {
    getMyCertificatePreview(record.id).then((res: any) => {
      if (res.success) {
        const link = document.createElement("a"); //创建a标签
        link.style.display = "none";
        link.href = res.result.previewUrl;
        console.log(link.href);
        document.body.appendChild(link);
        link.click(); //执行下载
        document.body.removeChild(link); //释放标签
      }
    });
    
  };

  const getMyCertificateList = async () => {
    const res: any = await getMyCertificate();
    // console.log(res);
    if (res.success) {
      setCertificateList(res.result);
    }
  };

  useEffect(() => {
    getMyCertificateList();
  }, []);
  return <div className="certificate-page">
    <h4 className="certificate-page-title">我的证书</h4>
    <h4 className="certificate-page-subtitle">查询和下载您在深开鸿相关认证、培训及人才培养活动中获得的电子证书。</h4>
    <div className="certificate-page-list">
      <div className="certificate-page-list-header">
        {certificateTypeList.map((item) => (
          <div key={item.value} className={certificateType === item.value ? 'certificate-page-list-header-item active' : 'certificate-page-list-header-item'} onClick={() => setCertificateType(item.value)}>{item.name}</div>
        ))}
      </div>
      { certificateListMemo.length > 0 ? 
       <div className='certificate-page-list-content'>
        {certificateListMemo.map((item) => (
          <div key={item.id} className='certificate-page-list-content-item'>
            <div className='certificate-item-title'>
              <img src={certificateTypeList.find((v) => v.value === item.certificateType)?.icon} alt="" />
              <span>{certificateTypeList.find((v) => v.value === item.certificateType)?.name}</span>
            </div>
            <div className='certificate-item-info'>
              <p className='text-nowrap' title={item.certificateName}>证书名称：{item.certificateName}</p>
              <p>证书类型：{certificateTypeList.find((v) => v.value === item.certificateType)?.name}</p>
              <p className='text-nowrap' title={item.certificateNo}>证书编号：{item.certificateNo}</p>
              <p>获奖时间：{item.issueDate}</p>
              <div className='certificate-item-action'>
                <div className='certificate-item-action-item' onClick={() => viewCertificate(item)}>
                  <img src={iconView} alt="" />
                  <span>查看证书</span>
                </div>
                <div className='certificate-item-action-item' onClick={() => downloadCertificate(item)}>
                  <img src={iconDownload} alt="" />
                  <span>下载证书</span>
                </div>
              </div>
            </div>
          </div>
        ))}
       </div> : 
       <div className='certificate-page-list-empty'>
        <img src={require('@/assets/images/support/empty.png')} alt="" />
        <p>暂未查询到您的证书</p>
        <p>如已参加相关活动但未查到证书，请核对账号实名信息或联系工作人员。</p>
       </div> }
    </div>
    {pdfViewModalData && <PdfViewModal fileName={pdfViewModalData?.pdfFileName} fileUrl={pdfViewModalData?.previewUrl} onCancel={() => setPdfViewModalData(null)} />}
  </div>;
};

export default Certificate;